<template>
  <Modal
    size="small"
    close-on-click-outside
    active
    class="confirmation-modal"
    @onClose="onClose()">
    <template #header>
      <div class="header">
        <h2>{{ header }}</h2>
        <div class="close-btn" @click="onClose()">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="inherit"
            stroke="inherit"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M15 15L1 1M1 15L15 1L1 15Z"
              stroke="inherit"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </div>
      </div>
    </template>
    <div slot="content">
      <div class="body">
        <div class="add-user-form">{{ message }}</div>
      </div>
      <div class="footer">
        <Button :label="submitBtnText" @onClick="handleSubmit"></Button>
        <Button
          :label="cancelBtnText"
          variant="tertiary"
          css-class="cancelBtn"
          @onClick="onClose"></Button>
        <custom-button-v2
          label="processing..."
          :disabled="processing"></custom-button-v2>
      </div>
    </div>
  </Modal>
</template>

<script>
import { CustomButtonV2 } from "@/components/common";

export default {
  name: "ConfirmationModal",
  components: {
    CustomButtonV2,
  },
  props: {
    // isOpen: { type: Boolean, required: true },
    header: { type: String, default: "" },
    message: { type: String, default: "" },
    submitBtnText: { type: String, default: "" },
    cancelBtnText: { type: String, default: "" },
  },
  data: () => {
    return {
      processing: false,
    };
  },
  methods: {
    beforeModalOpen() {
      this.processing = false;
    },
    onClose() {
      this.$emit("onModalClose");
    },
    handleSubmit() {
      this.processing = true;
      this.$emit("onConfirm");
    },
  },
};
</script>

<style lang="scss" scoped>
// Styles Imports
@import "@/styles/imports";

.confirmation-modal {
  &:focus {
    outline: none;
  }
  .wrapper {
    background-color: #ededed;
    padding: 24px;
    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .close-btn {
        cursor: pointer;
        svg {
          stroke: #00243d;
        }
      }
      h2 {
        color: #0073ab;
        font-family: "Maersk Headline Regular";
        font-size: 24px;
        margin: 0 0 1rem 0;
      }
    }
    .body {
      overflow-y: auto;
      // max-height: 670px;
      max-height: 70vh;
      max-width: 550px;
      width: 80vw;
      & .add-user-form {
        section {
          background-color: #ffffff;
          padding: 1rem;
          display: flex;
          flex-direction: column;
          margin-bottom: 1rem;
          .content {
            display: flex;
            flex-wrap: wrap;
            > div {
              flex-basis: 33.33%;
              padding-right: 1.5rem;
              margin-bottom: 1rem;
              box-sizing: border-box;
              &:nth-child(3),
              &:nth-child(6),
              &:nth-child(9) {
                padding: 0;
              }
            }
          }
          .title {
            flex: 1;
            margin-top: 0;
          }
        }
      }
    }
  }
}

.footer {
  display: flex;
  justify-content: flex-end;
  padding: 1rem 0 0 0;
  gap: 1rem;
}

.view-history-btn-container {
  flex: 1;
}
.radio-control {
  margin-top: 0.375rem;
}
.cancelBtn {
  margin-right: 1rem;
}
</style>

<style lang="scss">
@import "@/styles/imports";

.confirmation-modal {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;

  @include media("<=1024px") {
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
  }
}
.vm--modal {
  background: transparent !important;
  box-shadow: none !important;
}
</style>
